"use client";
import { useState } from "react";

export function useRedirectModal() {
  // Hooks
  const [isOpen, setOpen] = useState<boolean>(false);
  const [submitState, setSubmitState] = useState({});
  const [callback, setCallback] = useState<(args: any) => void>(() => {});

  // Functions
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);
  // Save the callback function and the props that would have been passed
  const saveCallback = (callbackFunction: Function, props: any) => {
    // Set props
    setSubmitState(props);
    // Save the callback function by passing argument-less fun
    // See https://medium.com/swlh/how-to-store-a-function-with-the-usestate-hook-in-react-8a88dd4eede1
    setCallback(() => callbackFunction);
  };
  // Run the saved callback
  const runCallback = () => {
    callback(submitState);
  };

  return {
    isOpen,
    onClose,
    onOpen,
    saveCallback,
    runCallback,
  };
}
